<mat-dialog-content class="adap-dialog-content">
  <app-dialog-header>
    <div class="adap-dialog-title">exceptions access</div>
    <div class="header-actions">
      <button *ngIf="readonly" class="adap-btn-blank" (click)="edit()">
        edit <mat-icon svgIcon="cvx-pencil"></mat-icon>
      </button>
      <button *ngIf="!readonly" class="adap-btn-blank" (click)="cancel()">
        cancel <mat-icon svgIcon="cvx-close"></mat-icon>
      </button>
      <button
        *ngIf="!readonly"
        class="adap-btn-filled"
        (click)="save()"
        [disabled]="exceptions?.length === 0"
      >
        save <mat-icon>save</mat-icon>
      </button>
    </div>
  </app-dialog-header>

  <div class="dialog-main-content">
    <app-multi-users-search
      label="exception"
      (selectionChanged)="onExceptionsChanged($event)"
      [readonly]="readonly"
    ></app-multi-users-search>
  </div>
</mat-dialog-content>
